import { afterNextRender, AfterViewInit, ApplicationInitStatus, ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { BankidSigningModalComponent } from '@app/bankid-signing-modal/bankid-signing-modal.component';
import { LoginService } from '@app/shared/services/login.service';
import { BankIdAuthenticateResultModel } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'nw-login-button',
  templateUrl: './login-button.component.html',
  styleUrl: './login-button.component.scss',
})
export class LoginButtonComponent {

  private loginService = inject(LoginService);
  private readonly initStatus = inject(ApplicationInitStatus);

  initialized = signal(false);

  constructor() {
    this.initStatus.donePromise.then(() => {
      this.initialized.set(true);
    });
  }

  loginWithBankId(bankidSigningModal: BankidSigningModalComponent) {
    bankidSigningModal.show();
  }

  bankIdSignIn(data: BankIdAuthenticateResultModel) {
    this.loginService.processBankIdLoginResult(data);
  }
}
